import { collection, deleteDoc, doc, getDocs, serverTimestamp, setDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { normalizeSchoolClass } from '../constants/classes';

export function bookDocId(className, subject) {
  const cls = normalizeSchoolClass(className) || String(className || '').trim();
  const sub = String(subject || '').trim().replace(/\s+/g, '_');
  return `${cls}__${sub}`;
}

export function dressDocId(dressType, size) {
  const t = String(dressType || '').trim().replace(/\s+/g, '_');
  const s = String(size || '').trim().replace(/\s+/g, '_');
  return `${t}__${s}`;
}

export async function listBookInventory() {
  if (!db) return [];
  const snap = await getDocs(collection(db, 'bookInventory'));
  return snap.docs
    .map((d) => ({ id: d.id, ...d.data() }))
    .sort((a, b) => {
      const c = String(a.class || '').localeCompare(String(b.class || ''));
      if (c !== 0) return c;
      return String(a.subject || '').localeCompare(String(b.subject || ''));
    });
}

export async function saveBookInventory({ className, subject, count }) {
  if (!db) throw new Error('Firestore not configured.');
  const cls = normalizeSchoolClass(className) || String(className || '').trim();
  const sub = String(subject || '').trim();
  if (!cls || !sub) throw new Error('Class and subject are required.');
  const id = bookDocId(cls, sub);
  await setDoc(
    doc(db, 'bookInventory', id),
    {
      class: cls,
      subject: sub,
      count: Math.max(0, Number(count) || 0),
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
  return id;
}

export async function deleteBookInventory(id) {
  if (!db) throw new Error('Firestore not configured.');
  await deleteDoc(doc(db, 'bookInventory', id));
}

export async function listDressInventory() {
  if (!db) return [];
  const snap = await getDocs(collection(db, 'dressInventory'));
  return snap.docs
    .map((d) => ({ id: d.id, ...d.data() }))
    .sort((a, b) => {
      const t = String(a.dressType || '').localeCompare(String(b.dressType || ''));
      if (t !== 0) return t;
      return String(a.size || '').localeCompare(String(b.size || ''));
    });
}

export async function saveDressInventory({ dressType, size, count }) {
  if (!db) throw new Error('Firestore not configured.');
  const type = String(dressType || '').trim();
  const sz = String(size || '').trim();
  if (!type || !sz) throw new Error('Dress type and size are required.');
  const id = dressDocId(type, sz);
  await setDoc(
    doc(db, 'dressInventory', id),
    {
      dressType: type,
      size: sz,
      count: Math.max(0, Number(count) || 0),
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
  return id;
}

export async function deleteDressInventory(id) {
  if (!db) throw new Error('Firestore not configured.');
  await deleteDoc(doc(db, 'dressInventory', id));
}
